module.exports = require("@vscode-alt/monaco-editor/esm/vs/editor/standalone/browser/standaloneEditor");